import { useQuery } from '@apollo/client';
import { Skeleton, Spinner } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import { ACCOUNT_INFORMATION } from '../settings/queries';

const AccountInformation = () => {
  const { t } = useTranslation();
  const { data: clientData, loading } = useQuery(ACCOUNT_INFORMATION);

  let contract = null;
  let contractStart = new Date(0);
  let contractEnd = new Date(0);

  if (clientData && clientData.viewer && clientData.viewer.client && clientData.viewer.client.contract) {
    contract = clientData.viewer.client.contract;
    contractStart = new Date(contract.startDate);
    contractEnd = new Date(contract.endDate);
  }

  const startDateStr = `${('0' + contractStart.getDate()).slice(-2)}/${('0' + (contractStart.getMonth() + 1)).slice(-2)}/${contractStart.getFullYear()}`;
  const endDateStr = `${('0' + contractEnd.getDate()).slice(-2)}/${('0' + (contractEnd.getMonth() + 1)).slice(-2)}/${contractEnd.getFullYear()}`;

  return (
    <div className="border border-gray-200 rounded p-4">
      <h2 className="pb-4">{t('settings.accountInformation.heading')}</h2>
      {loading && (
        <div className="flex justify-center">
          <Spinner size="3" role="status" />
        </div>
      )}
      {clientData && (
        <table className="accountInfoTable">
          <tbody>
            <tr>
              <td>{t('settings.accountInformation.companyNameLabel')}</td>
              <td>{clientData ? clientData.viewer.client.orgName : <Skeleton />}</td>
            </tr>
            {contract && contract.signer && contract.signer.firstName && (
              <tr>
                <td>{t('settings.accountInformation.signingContactLabel')}</td>
                <td>
                  {contract.signer.firstName || ''} {contract.signer.lastName || ''}
                </td>
              </tr>
            )}
            {clientData && clientData.viewer?.client?.contact?.firstName && (
              <tr>
                <td>{t('settings.accountInformation.primaryContactLabel')}</td>
                <td>
                  {clientData ? (
                    clientData.viewer.client.contact.firstName + ' ' + clientData.viewer.client.contact.lastName
                  ) : (
                    <Skeleton />
                  )}
                </td>
              </tr>
            )}
          </tbody>
          {contract && (
            <tbody className="mt-6">
              <tr>
                <td>{t('settings.accountInformation.agreementPeriodLabel')}</td>
                <td>
                  {contract
                    ? t('settings.accountInformation.agreementPeriodValue', {
                        startDate: startDateStr,
                        endDate: endDateStr,
                      })
                    : '-'}
                </td>
              </tr>
              <tr>
                <td>{t('settings.accountInformation.volumeOfInterviewsLabel')}</td>
                <td>
                  {contract
                    ? t('settings.accountInformation.interviewsCountValue', {
                        count: contract.quotas.interviewQuota,
                      })
                    : '-'}
                </td>
              </tr>
              {contract && contract.quotas.adminQuota && (
                <tr>
                  <td>{t('settings.accountInformation.adminUsersQuotaLabel')}</td>
                  <td>{contract ? contract.quotas.adminQuota : '-'}</td>
                </tr>
              )}
              {contract && contract.quotas.userQuota && (
                <tr>
                  <td>{t('settings.accountInformation.usersQuotaLabel')}</td>
                  <td>{contract.quotas.userQuota}</td>
                </tr>
              )}
            </tbody>
          )}
          {contract && (
            <tbody>
              <tr>
                <th>
                  <h2 className="text-start">{t('settings.accountInformation.interviewsSectionHeading')}</h2>
                </th>
              </tr>
              <tr>
                <td>{t('settings.accountInformation.usedInterviewsLabel')}</td>
                <td>{contract ? contract.quotas.usedInterviews : '-'}</td>
              </tr>
              <tr>
                <td>{t('settings.accountInformation.remainingInterviewsLabel')}</td>
                <td>{contract ? contract.quotas.interviewQuota - contract.quotas.usedInterviews : '-'}</td>
              </tr>
            </tbody>
          )}
          {contract && (
            <tbody>
              <tr>
                <th>
                  <h2 className="text-start">{t('settings.accountInformation.usersSectionHeading')}</h2>
                </th>
              </tr>
              <tr>
                <td>{t('settings.accountInformation.adminUsersCountLabel')}</td>
                <td>{contract ? contract.quotas.adminCount : '-'}</td>
              </tr>
              {contract && contract.quotas.adminQuota ? (
                <tr>
                  <td>{t('settings.accountInformation.remainingAdminUsersLabel')}</td>
                  <td>{contract ? contract.quotas.adminQuota - contract.quotas.adminCount : '-'}</td>
                </tr>
              ) : null}
              <tr>
                <td>{t('settings.accountInformation.usersCountLabel')}</td>
                <td>{contract ? contract.quotas.userCount : '-'}</td>
              </tr>
              {contract && contract.quotas.userQuota && (
                <tr>
                  <td>{t('settings.accountInformation.remainingUsersLabel')}</td>
                  <td>{contract ? contract.quotas.userQuota - contract.quotas.userCount : '-'}</td>
                </tr>
              )}
            </tbody>
          )}
        </table>
      )}
    </div>
  );
};

export default AccountInformation;
